import * as S from "./styles";

const DefaultForm = ({ name, children }) => {
  return (
    <S.Wrapper>
      <h2>{name}</h2>
      {children}
    </S.Wrapper>
  );
};

export default DefaultForm;
